export default __webpack_public_path__ + "static/media/stare.bb0391da.svg";